import styled from 'styled-components'

const StyledBitList = styled.div`
  padding-top: 1px;
`

export default StyledBitList
